import React from "react";

const FullScreenLoader = () => {
  return (
    <div style={styles.overlay}>
      <div style={styles.spinner}></div>
      <div style={styles.text}>Учитавање...</div>
    </div>
  );
};

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(255,255,255,0.8)",
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999
  },
  spinner: {
    width: "50px",
    height: "50px",
    border: "5px solid #ccc",
    borderTop: "5px solid #3498db",
    borderRadius: "50%",
    animation: "spin 1s linear infinite"
  },
  text: {
    fontSize: "18px"
  }
};

export default FullScreenLoader;
